import React, { Component } from "react";
import { Radio, Space, Checkbox } from "antd";
import { ModalItem, ButtonItem } from "./Items";

/**
 * Modal reutilizable para elegir el formato de una descarga masiva de recibos:
 * solo XML, solo PDF, o ambos en un mismo ZIP.
 * Usado desde PreNomina (una nómina) y desde el módulo de consulta masiva de Recibos.
 *
 * `opcionUnPdf` agrega "un solo PDF con todos los recibos", que no produce ZIP
 * sino un único archivo. Es opt-in porque quien la prenda tiene que saber
 * manejar el formato "unPdf" en su `onConfirm`; los consumidores que sólo hacen
 * ZIP no se enteran de que existe.
 *
 * `opcionSoloTimbrados` agrega el check para dejar fuera los recibos que todavía
 * no tienen CFDI. También es opt-in: quien la prenda recibe el flag como segundo
 * argumento de `onConfirm` y tiene que filtrar sus líneas con él.
 *
 * `titulo` reemplaza el "Descargar recibos" de siempre; PreNomina lo usa para decir
 * qué variante se va a bajar (ordinaria / sólo finiquitos).
 */
class ModalFormatoDescarga extends Component {
  state = { formato: "ambos", soloTimbrados: false };

  render() {
    const {
      visible, onClose, onConfirm, loading,
      opcionUnPdf = false, opcionSoloTimbrados = false,
      titulo = "Descargar recibos",
    } = this.props;
    const { formato, soloTimbrados } = this.state;
    const esUnPdf = formato === "unPdf";
    // En "Solo XML" el check no aporta: sin CFDI no hay XML, así que esa descarga
    // ya trae únicamente los timbrados.
    const mostrarSoloTimbrados = opcionSoloTimbrados && formato !== "xml";

    return (
      <ModalItem
        title={titulo}
        visible={visible}
        spinning={loading}
        onCancel={onClose}
        width={420}
      >
        <p style={{ color: "#888", fontSize: 12, marginBottom: 12 }}>
          {esUnPdf
            ? "Se descargará un único archivo PDF, un recibo por página."
            : "¿Qué quieres incluir en el ZIP?"}
        </p>
        <Radio.Group
          value={formato}
          onChange={(e) => this.setState({ formato: e.target.value })}
        >
          <Space direction="vertical">
            <Radio value="xml">Solo XML</Radio>
            <Radio value="pdf">Solo PDF</Radio>
            <Radio value="ambos">XML y PDF</Radio>
            {opcionUnPdf && (
              <Radio value="unPdf">Un solo PDF con todos los recibos</Radio>
            )}
          </Space>
        </Radio.Group>

        {mostrarSoloTimbrados && (
          <div style={{ marginTop: 14 }}>
            <Checkbox
              checked={soloTimbrados}
              onChange={(e) => this.setState({ soloTimbrados: e.target.checked })}
            >
              Solo los que ya están timbrados
            </Checkbox>
            <div style={{ color: "#888", fontSize: 11, marginTop: 4, marginLeft: 24 }}>
              Deja fuera los recibos sin CFDI, que salen marcados como vista previa.
            </div>
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>
          <ButtonItem onClick={onClose}>Cancelar</ButtonItem>
          <ButtonItem
            type="primary"
            loading={loading}
            onClick={() => onConfirm(formato, mostrarSoloTimbrados && soloTimbrados)}
          >
            Descargar
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }
}

export default ModalFormatoDescarga;
